function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as chatroomActions from './../chatroomActions';

export var Preview = function (_Component) {
    _inherits(Preview, _Component);

    function Preview() {
        var _temp, _this, _ret;

        _classCallCheck(this, Preview);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            file: '',
            imagePreviewUrl: ''
        }, _this.handleValidateClick = function (e) {
            var _this$props = _this.props,
                dispatch = _this$props.dispatch,
                user = _this$props.user,
                chatroomId = _this$props.chatroomId,
                chatroomUsers = _this$props.chatroomUsers;

            //We add the User to the list of users in the chatroom if he isn't in it already

            if (!(user.uid in chatroomUsers)) {
                dispatch(chatroomActions.addUserToChat(chatroomId, user.uid));
            }

            dispatch(chatroomActions.startUpload());
        }, _this.handleCancelClick = function (e) {
            var dispatch = _this.props.dispatch;

            dispatch(chatroomActions.cancelPreview());
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Preview.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var file = this.props.file;


        var reader = new FileReader();

        reader.onloadend = function () {
            _this2.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };

    Preview.prototype.render = function render() {
        var imagePreviewUrl = this.state.imagePreviewUrl;

        var $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = React.createElement(
                'div',
                { className: 'previewComponent' },
                React.createElement(
                    'div',
                    { className: 'imgPreview' },
                    React.createElement('img', { src: imagePreviewUrl, alt: 'preview' })
                ),
                React.createElement(
                    'form',
                    { className: 'input', encType: 'multipart/form-data' },
                    React.createElement(
                        'div',
                        { className: 'buttons' },
                        React.createElement('input', { className: 'valid', type: 'button', value: 'Valider', onClick: this.handleValidateClick }),
                        React.createElement('input', { className: 'cancel', type: 'button', value: 'Annuler', onClick: this.handleCancelClick })
                    ),
                    React.createElement('div', { id: 'message' })
                )
            );
        } else {
            $imagePreview = React.createElement(
                'div',
                { className: 'previewText' },
                'Please select an Image for Preview'
            );
        }
        return React.createElement(
            'div',
            { className: 'previewContainer' },
            $imagePreview
        );
    };

    return Preview;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        file: state.chatroom.file,
        chatroomId: state.chatroom.chatroomId,
        chatroomUsers: state.chatroom.users,
        user: state.user
    };
};

export default connect(mapStateToProps)(Preview);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/Preview/Preview.js
// module id = 225
// module chunks = 0